import { downloadFile } from '@/utils'
import errorHandler from '@/utils/errorHandler'

const paramsTransformer = ({ unifiedPDF, expedienteFormat, ...params }) => {
  return {
    unified_pdf: unifiedPDF,
    expediente_format: expedienteFormat,
    ...params
  }
}

export default (affectedId, filename, payload) => {
  const params = paramsTransformer(payload)
  const name = `Expediente.${payload.expedienteFormat}`

  return errorHandler(
    downloadFile(
      `purchase/quantification/case_file/${affectedId}/`,
      name,
      {
        config: {
          params
        }
      }
    )
  )
}



// WEBPACK FOOTER //
// ./src/services/purchase/record.js